module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.e0d5e07a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Light.woff
// module id = 325
// module chunks = 3